// extracted by mini-css-extract-plugin
export default {"root":"TAKxjxoM7toL0mbLsOzn","btn":"p93lRAfBFS6QaRdaKwA3","loader":"r5jzoMC1R3jYa2l0t7WW"};